import { createQueryClient } from "@core/api";

export const queryClient = createQueryClient();
